<template>
  <main class="main main--has-floating-buttons">
    <template v-if="season !== null">
      <portal to="headerTitle">
        {{ season.name[hotelSettings.details.primaryLanguage] }}
      </portal>
      <tabable-card cols="12 6@desktop">
        <tabable-card-content :title="$t(`lang.${hotelSettings.details.primaryLanguage}`)">
          <hm-card-inner>
            <hm-input v-model="season.name[hotelSettings.details.primaryLanguage]"
                      :lazy="true"
                      :disabled="season.deleted"
                      :label="$t('admin.pageSeason.title')"
                      validate="required"
                      name="title"
                      cols="12" />
          </hm-card-inner>
        </tabable-card-content>
      </tabable-card>
      <tabable-card cols="12 6@desktop">
        <tabable-card-content v-for="lang in hotelSettings.details.additionalLanguages" :title="$t(`lang.${lang}`)" :key="lang">
          <hm-card-inner>
            <hm-input v-model="season.name[lang]"
                      :lazy="true"
                      :disabled="season.deleted"
                      :label="$t('admin.pageSeason.title')"
                      name="title"
                      cols="12" />
          </hm-card-inner>
        </tabable-card-content>
      </tabable-card>
      <card :title="$t('admin.pageSeason.card.general')" cols="12 6@desktop">
        <hm-card-inner>
          <hm-input-select v-model="season.seasonType"
                           :disabled="season.deleted"
                           :label="$t('admin.pageSeason.seasonType')"
                           name="seasonType"
                           enum-name="SeasonType"
                           cols="12 6@tablet 6@desktop" />
        </hm-card-inner>
      </card>
      <card :title="$t('admin.pageSeason.card.color')" cols="12 6@desktop">
        <hm-card-inner>
          <hm-season-color-picker v-model="season.rgbColorCode"
                                  :disabled="season.deleted"
                                  :label="$t('admin.pageSeason.colorClass')"
                                  :help="$t('admin.pageSeason.colorClass_help')"
                                  name="colorClass"
                                  cols="12" />
        </hm-card-inner>
      </card>

      <card :title="$t('admin.pageSeason.card.usage')" cols="12" card-type="collapsible">
        <hm-card-inner v-if="!isEmpty(dates)" :full-size="true" :title="$t('admin.pageSeason.card.dateRanges')">
          <template v-for="date in dates">
            <hm-card-inner-line v-if="date.start === date.end" :title="date.start | toDate" :key="date.start" />
            <hm-card-inner-line v-else-if="date.start !== date.end" :title="`${ $options.filters.toDate(date.start) } - ${ $options.filters.toDate(date.end) }`" :key="date.start" />
          </template>
        </hm-card-inner>
        <hm-card-inner v-else>
          <hm-col cols="12">
            <p class="explanation-text">{{ $t('admin.pageSeason.hintNoSeasonDates') }}</p>
          </hm-col>
        </hm-card-inner>
      </card>

      <hm-floating-buttons id="actions" ref="floatingButtons">
        <hm-floating-button v-if="!season.deleted"
                            :label="$t('admin.pageSeason.actions.deleteSeason')"
                            icon="delete"
                            color="error"
                            @click="deleteSeason(false)" />
      </hm-floating-buttons>
    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import HmFloatingButton from '../../lib/inputs/HmFloatingButton';
import HmInputNumber from '../../lib/inputs/HmInputNumber';
import HmCardInner from '../../lib/layout/HmCardInner';
import HmCardInnerLine from '../../lib/layout/HmCardInnerLine';

export default {
  name: 'PageSeason',
  components: { HmCardInnerLine, HmCardInner, HmInputNumber, HmFloatingButton },
  autosave: [
    {
      name: 'season',
      variable: 'season',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        if (this.season.deleted === true) return;

        const toSave = cloneDeep(this.season);

        this.axios.put(this.serviceUrls.season.get(this, this.seasonId), toSave)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
            this.$serviceBus.$emit('season.list');
            this.$serviceBus.$emit('hotelSettings.update');
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      season: null,
      seasonId: this.$route.params.seasonId,
      dates: [],
    };
  },

  computed: {
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.season.get(this, this.seasonId))
        .then((response) => {
          if (isNil(this.season)) {
            this.season = response.data.data;
          }
        });
      this.axios.get(this.serviceUrls.season.dates(this, this.seasonId))
        .then((response) => {
          this.dates = response.data.data.dates;
        });
    },
    deleteSeason(confirmed = false) {
      if (confirmed === true) {
        this.axios.delete(this.serviceUrls.season.get(this, this.seasonId))
          .then((response) => {
            this.season = response.data.data;
            this.showSuccessMessage();
            this.$serviceBus.$emit('hotelSettings.update');
            this.$serviceBus.$emit('season.list');
            this.$router.push({
              name: 'seasons',
            });
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          });
      } else {
        this.showConfirmModal(
          this.$t('admin.pageSeason.confirmDeleteSeason'),
          (doNotShowAgain) => {
            this.deleteSeason(true);
          },
        );
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageSeason.vue